import FileSaver from 'file-saver';

import { TOKEN_KEY } from '@lib/providers/auth';

import { GetGauntletPointDto } from '@services/_api';
import client from '@services/client';

export const searchGauntletPoints = async (body: GetGauntletPointDto) => {
  return client.api.gauntletPointControllerSearch(body);
};

export const exportGauntletPoints = async (body: GetGauntletPointDto): Promise<void> => {
  const token = localStorage.getItem(TOKEN_KEY);
  const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

  const response = await fetch(`${baseUrl}/api/cstool/gauntlet-point/export`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => undefined);
    throw new Error(error?.message || 'Failed to export gauntlet points');
  }

  const blob = await response.blob();
  FileSaver.saveAs(blob, `gauntlet-point-${body.environment}-season${body.seasonId}.xlsx`);
};
